import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

import { getAemContentPolarisTabCollectionQuery } from '../queries';
import { DtlTabVariables, DTLUxlResponse } from './types';

export function getUxlVariablesForDTL(tabTitle: string): DtlTabVariables {
  return {
    input: {
      queryName: 'tabcollectionlist',
      filters: [
        {
          name: 'tags',
          expressions: [
            {
              value: tabTitle.toLowerCase(),
              operator: 'CONTAINS',
            },
          ],
        },
      ],
    },
  };
}

export function useGetUxlForDTL(): (tabTitle: string) => Promise<DTLUxlResponse | null> {
  const client = useApolloClient();
  const requestId = useClientEnvVarsStore(state => state.envVarsObject?.['REQUEST_ID']);

  return useCallback(
    async (tabTitle: string) => {
      try {
        const result = await client.query<DTLUxlResponse, DtlTabVariables>({
          query: getAemContentPolarisTabCollectionQuery,
          variables: getUxlVariablesForDTL(tabTitle),
          fetchPolicy: 'network-only',
          errorPolicy: 'all',
          context: {
            headers: {
              ...(requestId && { 'x-request-id': requestId }),
            },
          },
        });
        const { data, error } = result;
        if (error) {
          console.error('[useGetUxlForDTL] Error calling Apollo query for DTL operation:', error);
          return null;
        }
        return data ?? null;
      } catch (error) {
        console.error('[useGetUxlForDTL] Error calling Apollo query for DTL operation:', error);
        return null;
      }
    },
    [client]
  );
}
